interface Props {
  message: string
}

// Extracted out of ImagesListPage.tsx (PCD-9984 Part 2) — several unrelated files across the
// images/storage/vms plugin areas imported this from there purely for this trivial tooltip
// component, which created a circular import the moment any of them (transitively) got imported
// back into ImagesListPage.tsx itself (see CloneVirtualMachineModal's new deploy-mode import here).
// This file has no other dependencies, so it can't participate in that cycle.
export const TableHeaderTooltip = ({ message }: Props) => {
  return <div>{message}</div>
}
